<template>
  <component
    :is="tag"
    v-if="hasHtmlContent(content)"
    v-sanitize-html="joinSplitSentences(preserveEmptyParagraphs(content))"
    class="wysiwyg-visualizer" />
</template>

<script setup>
  import { sanitizeHtml } from '@/directives/sanitizeHtml';
  import { hasHtmlContent, joinSplitSentences, preserveEmptyParagraphs } from '@/helpers/htmlUtils';

  defineProps({
    content: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'div',
    },
  });

  const vSanitizeHtml = sanitizeHtml;
</script>

<style lang="scss" scoped>
  .wysiwyg-visualizer {
    :deep(:is(p, li, ul, ol, div, td, th, span, strong, em, a, h1, h2, h3, h4, h5, h6, blockquote)) {
      font-family: inherit !important;
      color: inherit;
    }

    //ajuste para traducciones con google translate
    :deep(.wysiwyg-line) {
      margin-bottom: inherit;
    }

    :deep(.wysiwyg-line:not(:last-child))::after {
      content: '';
      display: block;
      margin-bottom: inherit;
    }
  }
</style>
